import { useState } from "react";
import { useGetSchoolsQuery } from "./schoolsMutation";

const useSchoolQueries = (initialPage = 1, initialLimit = 100) => {
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);
  const [searchQuery, setSearchQuery] = useState("");

  const {
    data: schoolsData,
    isLoading,
    error,
    refetch,
    isFetching,
  } = useGetSchoolsQuery(
    {
      page,
      limit,
      searchQuery,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(Math.min(Math.max(newLimit, 1), 2000));
    setPage(1);
  };

  const handleSearchQueryChange = (query) => {
    setSearchQuery(query || "");
    setPage(1);
  };

  const schools = schoolsData?.results || [];
  const totalCount = schoolsData?.total_count || 0;

  return {
    schools,
    totalCount,
    currentPage: page,
    itemsPerPage: limit,
    searchQuery,
    isLoading: isLoading || isFetching,
    error: error
      ? {
          message: error.message || "Failed to fetch schools",
        }
      : null,
    handlePageChange,
    handleLimitChange,
    handleSearchQueryChange,
    refetch,
  };
};

export default useSchoolQueries;
